import { forwardRef, useMemo } from 'react';
import { Mobile } from './Mobile';
import Web from './Web';
import { generateSeries } from '@/components/CustomWebView/helper';
import { IS_WEB } from '@/utils/platform';

interface CustomWebViewProps {
  individualStatsData: unknown;
  timeSeriesData: unknown;
  appDisplayName: string | undefined;
  setType: string;
  webViewTitle: string;
}

const CustomWebView = forwardRef<HTMLIFrameElement, CustomWebViewProps>(
  function CustomWebView(
    {
      individualStatsData,
      timeSeriesData,
      appDisplayName,
      setType,
      webViewTitle,
    },
    ref,
  ) {
    const generatedTimeSeries = useMemo(
      () => generateSeries(timeSeriesData),
      [timeSeriesData],
    );

    if (!individualStatsData || !generatedTimeSeries) {
      return null;
    }

    return IS_WEB ? (
      <Web
        ref={ref}
        // @ts-ignore
        webViewTitle={webViewTitle}
        setType={setType}
        appDisplayName={appDisplayName}
        individualStatsData={individualStatsData}
        generatedTimeSeries={generatedTimeSeries}
      />
    ) : (
      <Mobile
        webViewTitle={webViewTitle}
        setType={setType}
        appDisplayName={appDisplayName}
        individualStatsData={individualStatsData}
        generatedTimeSeries={generatedTimeSeries}
      />
    );
  },
);

export default CustomWebView;
